import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fontWeight={400} fontFamily="sans-serif" fill="#2e3436"><path d="M2.035 7.008c-.531 0-1.031.421-1.031 1v7.012h8.012v-3.985h-2v1.985H3.004v-2.997H5.02V7.008z" style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        whiteSpace: "normal",
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} overflow="visible" /><path d="M8.02 1.008c-.532 0-1.032.421-1.032 1V9.02H15V1.977c0-.579-.521-.97-1.021-.97zm.968 3.015H13V7.02H8.988z" style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        whiteSpace: "normal",
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;